import React from 'react'
import { Feed } from '~/models'
import { memo } from '~/ui/component'
import { FormField } from '~/ui/form'
import { ResourceField } from '~/ui/resources/components'

const HomeScreenFeedWidgetFields = memo('HomeScreenFeedWidgetFields', () => {

  //------
  // Rendering

  function render() {
    return (
      <FormField name='feed' i18nKey='home_screen.feed'>
        {bind => (
          <ResourceField Model={Feed} {...bind}/>
        )}
      </FormField>
    )
  }

  return render()

})

export default HomeScreenFeedWidgetFields